import { defineMessages } from 'react-intl';

export default defineMessages({
    changeBoundMessage: {
        id: 'endorsement.premier.views.change-bound.Change Have Been Submitted For Review',
        defaultMessage: 'Change Have Been Submitted For Review',
    },
    contactAgentMessage: {
        id: 'endorsement.premier.views.change-bound.This is a quotation only and requested changes are not in force until',
        defaultMessage: 'This is a quotation only and requested changes are not in force until'
    },
    contactUnderwriterMessage: {
        id: 'endorsement.premier.views.change-bound.Premier Canada Assurance or Premier Marine has provided confirmation of coverage in writing.',
        defaultMessage: 'Premier Canada Assurance or Premier Marine has provided confirmation of coverage in writing.'
    },
    backToPolicy: {
        id: 'endorsement.premier.views.contact-agent.Back to Policy',
        defaultMessage: 'Back to Policy'
    },
    backToHome: {
        id: 'endorsement.premier.views.contact-agent.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    changeBound: {
        id: 'endorsement.premier.views.change-bound.Change is Bound',
        defaultMessage: 'Change is Bound'
    },
    paymentSchedule: {
        id: 'gw-portals-policytransaction-premier-angular.TransactionConfirmation.TransactionConfirmation.You can check the payment schedule...',
        defaultMessage: 'You can check the payment schedule and invoices here: {link}'
    },
    lobPolicy: {
        id: 'gw-portals-policytransaction-premier-angular.TransactionConfirmation.TransactionConfirmation.LOB policy',
        defaultMessage: '{lob} policy: {policyNumber}'
    },
    policyBillingPage: {
        id: 'gw-portals-policytransaction-premier-angular.TransactionConfirmation.TransactionConfirmation.Policy Billing Page',
        defaultMessage: 'Policy Billing Page'
    },
    referenceNumber: {
        id: 'gw-portals-policytransaction-premier-angular.TransactionConfirmation.TransactionConfirmation.Reference Number',
        defaultMessage: 'Reference Number: {refNumber}'
    },
    viewJobDetails: {
        id: 'gw-portals-policytransaction-premier-angular.TransactionConfirmation.TransactionConfirmation.View Job Details',
        defaultMessage: 'View {jobType} Details'
    }
});
